export default __webpack_public_path__ + "static/ahu_w.c7d247e74c5ab349dc888e19b266a707.png";